import parseISO from "date-fns/parseISO";

/**
 * Parses date if passed as string, returns null if no date or string is passed
 */
export default function parseDate(date: string | Date): Date | null {
    return typeof date === 'string' ? parseISO(date) : date ?? null
}